import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCountries, createCountry, fetchCountry, modifyCountry, deleteCountryApi, changeStatus } from '../../api/countryApi';

export const getCountries = createAsyncThunk('country/getCountries', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchCountries(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addCountry = createAsyncThunk('country/addCountry', async (payload, { rejectWithValue }) => {
  try {
    const response = await createCountry(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getCountryDetails = createAsyncThunk('country/getCountryDetails', async (countryId, { rejectWithValue }) => {
  try {
    const response = await fetchCountry(countryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateCountry = createAsyncThunk('country/updateCountry', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyCountry(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteCountry = createAsyncThunk('country/deleteCountry', async (countryId, { rejectWithValue }) => {
  try {
    const response = await deleteCountryApi(countryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('country/changeActiveStatus', async (countryId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(countryId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const countrySlice = createSlice({
  name: 'country',
  initialState: {
    countries: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries = action.payload;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default countrySlice.reducer;
